import { useForm } from 'react-hook-form';
import { FormRendererAPIType, RawFormComponentType } from 'components/common/form';
import { prepareFormElementProps } from 'components/common/form/formTools';
import ReactHookFormController from 'components/common/form/layout/ReactHookFormController';
import React, { useEffect } from 'react';

interface ITextTinyMCEVariable {
    value: string;
    name: string;
    onChange: (value: string) => void;
}

export default function TextHtmlVariable({ value, name, onChange }: ITextTinyMCEVariable) {
    const {
        setValue: hookFormSetValue,
        control,
        getValues: hookFromGetValues,
        watch,
    } = useForm({
        defaultValues: {
            text: value,
        },
    });
    const formActions = {
        hookFormControl: control,
        hookFormGetValues: hookFromGetValues,
        hookFormSetValue: hookFormSetValue,
        hookFormWatch: watch,
        formDidMount: true,
    } as FormRendererAPIType;

    const textValue = watch('text');

    useEffect(() => {
        onChange(textValue);
    }, [textValue]);

    const codeEditorProps = {
        form: formActions,
        component: {
            component: 'CodeEditor',
            name: 'text',
            props: {
                value,
                mode: 'html',
                height: 150,
            },
        } as RawFormComponentType,
    };

    return <ReactHookFormController elementProps={prepareFormElementProps(codeEditorProps)}></ReactHookFormController>;
}
